export default __webpack_public_path__ + "static/media/logo1.608d6d6d.png";